// ADR 7.10.26w §2 — where each companion surface is drawn. Pure.
//
// One rule for the dock and one for the app card, replacing `ShellBody`'s old
// column-or-sheet ternary and `HeaderApps`' `DOCK_IS_SHEET`. `PAGED` is v's
// table (§1.6), imported rather than re-declared, so the web has one answer to
// "is this layout paged". Every lookup is keyed, never a quoted compare
// (6.9.26p AC6).

import type { PaneLayout } from '../../layout/useWindowClass'
import { PAGED } from '../../layout/spread/readSpread'
import type { SpreadLayout } from '../../wasm'

/** Beside the page at `list_detail`, a bottom sheet, or the companion page. */
export type SurfaceHost = 'column' | 'sheet' | 'page'

/** The app card has no column: a modal sheet, or the companion page. */
export type CardHost = 'sheet' | 'page'

const COLUMN: Record<PaneLayout, boolean> = { single_pane: false, list_detail: true }

/**
 * `page › column › sheet`. `pane` is the **whole window's** pane layout; at a
 * paged spread the answer is `page` whatever it is, and otherwise the leading
 * page's class equals the window's, so the two readings never disagree.
 */
export function dockHost(spread: SpreadLayout, pane: PaneLayout): SurfaceHost {
  if (PAGED[spread]) return 'page'
  return COLUMN[pane] ? 'column' : 'sheet'
}

export function cardHost(spread: SpreadLayout): CardHost {
  return PAGED[spread] ? 'page' : 'sheet'
}

/** 6.10.26l D4 — a card never opens over a sheet dock; beside a column or a page it may. */
export const CLOSES_DOCK: Record<SurfaceHost, boolean> = { sheet: true, column: false, page: false }
